import { hydrate } from "@propublica/pp-svelte/util/hydrate-baker.mjs";

import * as componentClasses from "./svelte-components.js";

// @ts-ignore (TODO(@alecglassford): Fix type problems with componentClasses)
hydrate(componentClasses);

// Add your code here! (or write other JS modules and use their imports here)

import rafEventsInit from "./rafEvents.js";
rafEventsInit();

/* ------------------------------------------------------------
 * Split Words
 */

/**
 * @param {string} querySelector
 */
function splitIntoWords(querySelector) {
    const elements = document.querySelectorAll(querySelector);
    elements.forEach(function (element) {
        element.innerHTML = element.textContent?.replace(/\w+/g, "<span>$&</span>");
    });
}

/* Text Fade ------------------------------------------------
*/

const fadeScroll = new IntersectionObserver(
    function (items, observer) {
      items.forEach((item) => {
        if (item.isIntersecting) {
          item.target.classList.add("fade-text--scrolled-into-view");
        } else {
          item.target.classList.remove("fade-text--scrolled-into-view");
        }
      });
    },
    {
      root: null,
      rootMargin: "0px 0px -25% 0px",
      threshold: 0.25,
    }
  );

  document.querySelectorAll(".fade--text").forEach((item) => fadeScroll.observe(item));
    document.querySelectorAll(".fade--text--long").forEach((item) => fadeScroll.observe(item));


/* ------------------------------------------------------------
 * Scrollama
 */

import scrollama from "scrollama";
const scroller = scrollama();

function scrollerInit() {
    // let steps = document.querySelectorAll(".scrolly__step");

    function handleResize() {
        // var stepH = Math.floor(window.innerHeight * 1);

        // steps.forEach((step) => {
        //     step.style.setProperty("min-height", stepH + "px");
        // });

        scroller.resize();
    }

    function handleStepEnter(response) {
        if (response.element.classList.contains("scrolly__step")) {
            response.element.classList.add("scrolly__step--active");

            const fxStackLayers = document.querySelectorAll(
                ".fixed-bg-stack *[data-fixed-bg-stack]",
            );
            let inactiveLayers = Array.from(fxStackLayers);

            if (
                response.element.dataset.stepFxShow ||
                response.element.dataset.stepFxFade
            ) {
                if (response.element.dataset.stepFxShow) {
                    const target = response.element.dataset.stepFxShow;
                    const element = document.querySelector(
                        `.fixed-bg-item[data-fixed-bg-stack="${target}"]`,
                    );
                    element.dataset.fx = "show";
                    console.log("filtering out: " + element);
                    inactiveLayers = inactiveLayers.filter(
                        (item) => item !== element,
                    );
                }
                if (response.element.dataset.stepFxFade) {
                    const target = response.element.dataset.stepFxFade;
                    const element = document.querySelector(
                        `.fixed-bg-item[data-fixed-bg-stack="${target}"]`,
                    );
                    element.dataset.fx = "fade";
                    console.log("filtering out: " + element);
                    inactiveLayers = inactiveLayers.filter(
                        (item) => item !== element,
                    );
                }
            }

            inactiveLayers.forEach(function (element) {
                element.dataset.fx = "hide";
            });

            if (response.element.dataset.stepFxAfterBg) {
                if (response.direction == "down") {
                    const progression = response.element.dataset.stepFxAfterBg;
                    const element = document.querySelector("body");
                    element.dataset.fx = `bg-${progression}`;
                }
            }
        } else if (response.element.classList.contains("js-intersect-watch")) {
            // response.element.parentNode.querySelector(
            //     ".js-intersect-opacity",
            // ).style.opacity = 1;
        }
    }

    function handleStepExit(response) {
        // console.log(response);

        if (response.element.classList.contains("scrolly__step")) {
            response.element.classList.remove("scrolly__step--active");

            if (response.element.dataset.stepFxBeforeBg) {
                if (response.direction == "up") {
                    const progression = response.element.dataset.stepFxBeforeBg;
                    const element = document.querySelector("body");
                    element.dataset.fx = `bg-${progression}`;
                }
            }
        } else if (response.element.classList.contains("js-intersect-watch")) {
            // response.element.parentNode.querySelector(
            //     ".js-intersect-opacity",
            // ).style.opacity = 0;
        }
    }

    function handleStepProgress(response) {
        // console.log(response.progress);
    }

    document.addEventListener("rafResize", () => {
        handleResize();
    });

    handleResize();
    scroller
        .setup({
            step: ".scrolly .scrolly__step, .js-intersect-watch",
            progress: true,
        })
        .onStepEnter(handleStepEnter)
        .onStepExit(handleStepExit)
        .onStepProgress(handleStepProgress);
}

/* ------------------------------------------------------------
 * Init
 */

document.addEventListener("DOMContentLoaded", () => {
    let elements = document.querySelectorAll(
        ".js-intersect-opacity.sticky-element",
    );
    elements.forEach(function (stickyElement) {
        // stickyElement.style.opacity = 0;
    });

    splitIntoWords(".js-split-into-words");

    scrollerInit();
});
